<form *ngIf="formData && calendarTranslate" [formGroup]="formData">
  <div class="ui-g form-group master-data">
    <div [kv-form-element]="{ label: 'customerDetail.source_system', md: '3', required: true }">
      <p-dropdown #sourceSystem data-testid="sourceSystem" [options]="source_systems" formControlName="source_system" [style]="{'width':'100%' }" (onChange)="sourceSystemChange()"></p-dropdown>
    </div>
    <div [kv-form-element]="{ label: 'customerDetail.code', md: '3' }">
      <input type="text" pInputText #customerCode data-testid="customerCode" formControlName="customerCode" placeholder="{{ 'customerDetail.codePlace' | translate}}" (change)="customerCodeChange(customerCode)" />
    </div>
    <div [kv-form-element]="{ label: 'customerDetail.group_number', md: '3' }">
      <input type="number" min="0" pInputText formControlName="group_number" />
    </div>
    <div [kv-form-element]="{ label: 'customerDetail.preferred_store', md: '3' }">
      <p-dropdown [options]="stores" formControlName="preferred_store_id" [filter]="true" [style]="{'width':'100%' }"></p-dropdown>
    </div>

    <div [kv-form-element]="{ label: 'customerDetail.surname', md: '4' }">
      <input type="text" pInputText formControlName="surname" />
    </div>
    <div [kv-form-element]="{ label: 'customerDetail.name', md: '4' }">
      <input type="text" pInputText formControlName="name" />
    </div>
    <div [kv-form-element]="{ label: 'customerDetail.fiscal_code', md: '4' }">
      <input type="text" pInputText formControlName="fiscal_code" />
    </div>


    <div [kv-form-element]="{ label: 'customerDetail.birth_city', md: '4'}">
      <input type="text" pInputText formControlName="birth_city" />
    </div>

    <div [kv-form-element]="{ label: 'customerDetail.birthday', md: '4'}">
      <app-kv-calendar
        class="over"
        [inputName]="'birthday'"
        [defaultDate]="formData.controls.birthday.value"
        [defaultValue]="formData.controls.birthday.value"
        [formData]="formData"
        [maxDate]="maxDate"
        [yearRange]="'1900:2019'"
      ></app-kv-calendar>
    </div>

    <div [kv-form-element]="{ label: 'customerDetail.sex', md: '4'}">
      <p-radioButton name="sex" formControlName="sex" value="M" [label]="'customerDetail.sex_male' | translate"></p-radioButton>
      <p-radioButton name="sex" formControlName="sex" value="F" [label]="'customerDetail.sex_female' | translate" ></p-radioButton>
      <p-radioButton name="sex" formControlName="sex" value="A" [label]="'customerDetail.sex_other' | translate"></p-radioButton>
    </div>



    <div [kv-form-element]="{label: 'customerDetail.education', md: '4'}">
      <p-dropdown [options]="educations" formControlName="education" [style]="{'width':'100%'}"></p-dropdown>
    </div>
    <div [kv-form-element]="{label: 'customerDetail.employment', md: '4'}">
      <p-dropdown [options]="employments" formControlName="occupation" [style]="{'width':'100%'}"></p-dropdown>
    </div>


    <div class="ui-g-12">
      <hr />
    </div>
  </div>

  <div class="ui-g form-group master-data">
    <div [kv-form-element]="{ label: 'customerDetail.address', md: '12' }">
    </div>
    <div [kv-form-element]="{ label: 'customerDetail.country', md: '3' }">
      <p-autoComplete
      [suggestions]="countries"
      [(ngModel)]="model.country"
      [ngModelOptions]="{standalone: true}"
      (completeMethod)="filterCountrySingle($event)"
      (onSelect)="onSelectCountry($event)"
      placeholder="{{ 'common.country' | translate }}"
      (onClear)="onClearCountry()"
      [minLength]="2"
      field="name">
    </p-autoComplete>
    </div>
    <div [kv-form-element]="{ label: 'customerDetail.states', md: '3' }">
      <p-autoComplete
      [suggestions]="states"
      [(ngModel)]="model.state"
      [ngModelOptions]="{standalone: true}"
      (completeMethod)="filterStateSingle($event)"
      (onSelect)="onSelectState($event)"
      placeholder="{{ 'common.state' | translate }}"
      (onClear)="onClearState()"
      [minLength]="2"
      field="name"
      [disabled]="!model.country"
      >
      </p-autoComplete>
    </div>
    <div [kv-form-element]="{ label: 'customerDetail.province', md: '3' }">
      <p-dropdown [options]="provinces" formControlName="province_id" [filter]="true" [style]="{'width':'100%' }"></p-dropdown>
    </div>
    <div [kv-form-element]="{ label: 'customerDetail.city', md: '3' }">
      <input type="text" pInputText formControlName="city" />
    </div>

    <div [kv-form-element]="{ label: 'customerDetail.zip', md: '2' }">
      <input type="text" pInputText formControlName="zip_code" />
    </div>
    <div [kv-form-element]="{ label: 'customerDetail.toponym', md: '1' }">
      <p-dropdown [options]="toponyms" formControlName="toponym_id" [filter]="true" [style]="{'width':'100%' }"></p-dropdown>
    </div>
    <div [kv-form-element]="{ label: 'customerDetail.address_venue', md: '3' }">
      <input type="text" pInputText formControlName="address" />
    </div>
    <div [kv-form-element]="{ label: 'customerDetail.number', md: '1' }">
      <input type="text" pInputText formControlName="address_number" />
    </div>
    <div [kv-form-element]="{ label: 'customerDetail.extended_address', md: '5' }">
      <input type="text" pInputText formControlName="address_2" />
    </div>


    <div [kv-form-element]="{ label: 'customerDetail.phone', md: '4' }">
      <input type="text" pInputText formControlName="phone_primary" />
    </div>
    <div [kv-form-element]="{ label: 'customerDetail.mobile', md: '4' }">
      <input type="text" pInputText formControlName="phone_mobile" />
    </div>
    <div [kv-form-element]="{ label: 'customerDetail.other_phone', md: '4' }">
      <input type="text" pInputText formControlName="other_phone" />
    </div>

    <div [kv-form-element]="{ label: 'customerDetail.mail_1', md: '6' }">
      <input type="text" pInputText formControlName="email_primary" />
    </div>
    <div [kv-form-element]="{ label: 'customerDetail.mail_2', md: '6' }">
      <input type="text" pInputText formControlName="email_secondary" />
    </div>
    <div class="ui-g-12">
      <hr style="border-top:0px;border-color:#dde3e6">
    </div>
  </div>

  <div class="ui-g form-group master-data">
    <div [kv-form-element]="{ label: 'customerDetail.authorizations', md: '12' }"></div>

    <div [kv-form-element]="{ label: 'customerDetail.authorization_newsletter', md: '6' }">
      <p-dropdown [options]="paramsTypeNewsletter" formControlName="flg_newsletter" [style]="{'width':'25%'}"></p-dropdown>
    </div>

    <div [kv-form-element]="{ label: 'customerDetail.authorization_sendname', md: '6' }">
      <p-inputSwitch formControlName="flag_register_name"></p-inputSwitch>
    </div>
    <div [kv-form-element]="{ label: 'customerDetail.authorization_generalcommunications', md: '6' }">
      <p-inputSwitch formControlName="flag_general_communications"></p-inputSwitch>
    </div>
    <div [kv-form-element]="{ label: 'customerDetail.authorization_marketingresearch', md: '6' }">
      <p-inputSwitch formControlName="flag_market_research"></p-inputSwitch>
    </div>
    <div [kv-form-element]="{ label: 'customerDetail.authorization_privacy', md: '6', required: true}">
      <p-inputSwitch formControlName="flag_privacy"></p-inputSwitch>
    </div>
    <div [kv-form-element]="{ label: 'customerDetail.authorization_profiling', md: '6' }">
      <p-inputSwitch formControlName="flag_profiling"></p-inputSwitch>
    </div>
    <div [kv-form-element]="{ label: 'customerDetail.authorization_marketingactivity', md: '6' }">
      <p-inputSwitch formControlName="flag_marketing_activities"></p-inputSwitch>
    </div>
    <div [kv-form-element]="{ label: 'customerDetail.authorization_purchasecommunications', md: '6' }">
      <p-inputSwitch formControlName="flag_purchase_communications"></p-inputSwitch>
    </div>
    <div [kv-form-element]="{ label: 'customerDetail.authorization_push', md: '6' }">
      <p-inputSwitch formControlName="flag_push_notifications"></p-inputSwitch>
    </div>
  </div>
</form>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/basicinfo/basic.component.html